"use client";
import React from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";

export const MenuItem = ({
  setActive,
  active,
  item,
  children,
}: {
  setActive: (item: string) => void;
  active: string | null;
  item: string;
  children?: React.ReactNode;
}) => {
  return (
    <div onMouseEnter={() => setActive(item)} className="relative h-full">
      <motion.button
        type="button"
        transition={{ duration: 0.3 }}
        className="h-full inline-flex items-center cursor-pointer text-foreground hover:text-primary font-medium leading-none"
      >
        {item}
      </motion.button>

      {active === item && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2">
          <div className="dark:bg-gray-800 backdrop-blur-lg rounded-2xl overflow-hidden border border-border shadow-xl">
            <div className="w-max p-4">
              {children}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const Menu = ({
  setActive,
  children,
}: {
  setActive: (item: string | null) => void;
  children: React.ReactNode;
}) => {
  return (
    <nav
      onMouseLeave={() => setActive(null)}
      className="relative h-16 rounded-full dark:bg-gray-900 bg-white shadow-md flex items-center justify-center space-4 px-4"
    >
      {children}
    </nav>
  );
};

export const ProductItem = ({
  title,
  description,
  href,
  src,
}: {
  title: string;
  description: string;
  href: string;
  src: string;
}) => {
  return (
    <Link href={href} className="flex space-x-2">
      <Image
        src={src}
        width={100}
        height={50}
        alt={title}
        className="flex-shrink-0 rounded-md shadow-2xl"
      />
      <div>
        <h4 className="text-xl font-bold text-foreground">{title}</h4>
        <p className="text-muted-foreground text-sm max-w-[10rem]">
          {description}
        </p>
      </div>
    </Link>
  );
};

export const HoveredLink = ({ children, ...rest }: any) => {
  return (
    <Link
      {...rest}
      className="text-muted-foreground hover:text-primary transition-colors"
    >
      {children}
    </Link>
  );
};
